import { Paper, styled } from '@mui/material';

const RootContainer = styled('div')(() => ({
  width: '100%',
}));

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
  overflow: 'hidden',
}));

export { RootContainer, PaperStyled };
